/**
 * Returns "active" when the current path matches a menu target.
 * Home uses exact match; other routes also match nested detail URLs.
 */
export function navActive(pathname, paths, { exact = false } = {}) {
  const list = Array.isArray(paths) ? paths : [paths];
  const matched = list.some((path) => {
    if (exact || path === '/') {
      return pathname === path;
    }
    return pathname === path || pathname.startsWith(`${path}/`);
  });
  return matched ? 'active' : undefined;
}

export const PAGES_PATHS = ['/gallery', '/tour', '/tour-details', '/faq'];
export const ACTIVITY_PATHS = ['/activities', '/activities-details'];
export const TOUR_PATHS = ['/tour', '/tour-details'];
